module.exports = __webpack_public_path__ + "6f22f142874cf23e04a152b0f509bc2c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont/iconfont.ttf?t=1462848962
// module id = 1047
// module chunks = 73